/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Column } from "primereact/column";
import { accessAPI, TablaFiltrable } from "../../shared";
import { abrirActividad, CAMPOS_BUSQUEDA, diasEnPasoBody, filasDePasos, filtrosDePasos } from "./pasosActividades";

import { Accordion, AccordionTab } from "primereact/accordion";
import { Skeleton } from "primereact/skeleton";

export default function ActividadesAbiertas({ toast }) {
  const navigate = useNavigate();
  const [pasos, setPasos] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    accessAPI(
      "GET",
      "admin/destacados/actividadesabiertas",
      null,
      (respuesta) => {
        setPasos(respuesta);
        setLoading(false);
      },
      (respuesta) => {
        toast.current.show({ severity: "error", summary: "Error", detail: respuesta[0]?.msg || "Error al cargar actividades", sticky: true });
        setLoading(false);
      }
    );
  }, [toast]);

  if (loading) {
    return (
      <div css={{ marginTop: "1em" }}>
        <Skeleton width="100%" height="3.5rem" borderRadius="6px" />
      </div>
    );
  }

  if (!pasos || pasos.length === 0) {
    return null;
  }

  // Los procesos de juguetes (esjuguetes) tienen un flujo muy distinto: se separan en su
  // propia sección colapsada para no contaminar la operativa del día a día.
  const juguetes = pasos.filter((p) => p.actividad.proceso.esjuguetes);
  const resto = pasos.filter((p) => !p.actividad.proceso.esjuguetes);

  // Cada sección va en su propio Accordion (con marginTop) para que la separación
  // entre "Actividades abiertas" y la de juguetes sea igual a la del resto de secciones.
  const accordionCss = {
    marginTop: "1em",
    "& .p-accordion-header-link": { color: "black" },
    "& .p-toggleable-content": { transition: "max-height 0.15s ease" }
  };

  return (
    <>
      {resto.length > 0 && (
        <Accordion activeIndex={null} css={accordionCss}>
          <AccordionTab header={`Actividades abiertas (${resto.length})`}>
            <TablaFiltrable
              value={filasDePasos(resto)}
              searchFields={CAMPOS_BUSQUEDA}
              filtros={filtrosDePasos(true)}
              emptyMessage="No hay actividades abiertas"
              nombreArchivo="actividades_abiertas"
              sortMode="multiple"
              removableSort
              onRowClick={abrirActividad(navigate)}
              css={{ "& .p-datatable-tbody > tr": { cursor: "pointer" } }}
            >
              <Column header="Cliente" field="_cliente" sortable />
              <Column header="Proceso" field="_proceso" sortable />
              <Column header="Actividad" field="_actividad" sortable />
              <Column header="Paso actual" field="_paso" sortable />
              <Column
                header="Decisores"
                field="_decisores"
                sortField="_decisoresTexto"
                sortable
                body={(fila) => (
                  <ul css={{ margin: 0, paddingLeft: 0, listStyle: "none" }}>
                    {fila._decisores.map((d, k) => (
                      <li key={k}>{d}</li>
                    ))}
                  </ul>
                )}
                exportValue={(fila) => fila._decisores.join(", ")}
              />
              <Column
                header="Días en el paso actual"
                field="_diasEnPaso"
                sortable
                body={diasEnPasoBody}
                exportValue={(fila) => fila._diasEnPaso ?? "-"}
                style={{ width: "10em" }}
              />
            </TablaFiltrable>
          </AccordionTab>
        </Accordion>
      )}
      {juguetes.length > 0 && (
        <Accordion activeIndex={null} css={accordionCss}>
          <AccordionTab header={`Actividades abiertas - juguetes (${juguetes.length})`}>
            <TablaFiltrable
              value={filasDePasos(juguetes)}
              searchFields={CAMPOS_BUSQUEDA}
              filtros={filtrosDePasos(true)}
              emptyMessage="No hay actividades de juguetes abiertas"
              nombreArchivo="actividades_juguetes_abiertas"
              sortMode="multiple"
              removableSort
              onRowClick={abrirActividad(navigate)}
              css={{ "& .p-datatable-tbody > tr": { cursor: "pointer" } }}
            >
              <Column header="Cliente" field="_cliente" sortable />
              <Column header="Proceso" field="_proceso" sortable />
              <Column header="Actividad" field="_actividad" sortable />
              <Column header="Paso actual" field="_paso" sortable />
              <Column
                header="Decisores"
                field="_decisores"
                sortField="_decisoresTexto"
                sortable
                body={(fila) => (
                  <ul css={{ margin: 0, paddingLeft: 0, listStyle: "none" }}>
                    {fila._decisores.map((d, k) => (
                      <li key={k}>{d}</li>
                    ))}
                  </ul>
                )}
                exportValue={(fila) => fila._decisores.join(", ")}
              />
              <Column
                header="Días en el paso actual"
                field="_diasEnPaso"
                sortable
                body={diasEnPasoBody}
                exportValue={(fila) => fila._diasEnPaso ?? "-"}
                style={{ width: "10em" }}
              />
            </TablaFiltrable>
          </AccordionTab>
        </Accordion>
      )}
    </>
  );
}
